export default __webpack_public_path__ + "static/media/CNo.83-6.49378b4d.jpg";